import { MemberList } from '~/components/upload/lithostrat/member/MemberList';

export default function UploadMemberListRoute() {
  return <MemberList />;
}
